/* eslint-disable import/no-cycle */
/* eslint-disable react/no-danger */
import React from 'react';
import IllnessJPG from '@assets/images/illness.jpg';
import IllnessMobileJPG from '@assets/images/illness-mobile.jpg';
import { ContainerSmall } from '~/utils/styles/utils';
import HeaderFooterLayout from '~/components/molecules/HeaderFooterLayout/HeaderFooterLayout';
import { useTranslationContext } from '~/pages/depression';
import { useTranslationContext as useTranslationContextEn } from '~/pages/en/depression';

const DepressionPage: React.FC = () => {
  const t = useTranslationContext();
  const tEn = useTranslationContextEn();

  return (
    <>
      <HeaderFooterLayout
        desktopHero={IllnessJPG}
        mobileHero={IllnessMobileJPG}
        altHero="Modell eines Gehirns zur Krankheitserklärung von Depression."
        enLink="/en/depression/"
        deLink="/depression/"
      >
        <ContainerSmall>
          <div
            dangerouslySetInnerHTML={{
              __html: t('DepressionContent1') || tEn('DepressionContent1'),
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: t('DepressionContent2') || tEn('DepressionContent2'),
            }}
          />
        </ContainerSmall>
      </HeaderFooterLayout>
    </>
  );
};

export default DepressionPage;
